import { Box, Button, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface DashboardStatsErrorProps {
  error: Error | null;
  onRetry: () => void;
}

/**
 * Error state component for dashboard stats with retry functionality
 */
export const DashboardStatsError: React.FC<DashboardStatsErrorProps> = ({ error, onRetry }) => {
  const { t } = useTranslation();

  return (
    <Box p={8} textAlign="center">
      <VStack gap={4}>
        <Text fontSize="lg" fontWeight="medium" color="red.500">
          {t('dashboard.stats.error')}
        </Text>
        <Text fontSize="sm" color="gray.600">
          {error instanceof Error ? error.message : t('common.error')}
        </Text>
        <Button onClick={onRetry} colorPalette="blue" variant="outline">
          {t('common.retry', { defaultValue: 'Retry' })}
        </Button>
      </VStack>
    </Box>
  );
};
